"use strict";

/**
 * Handle thumbs up and thumbs down logic
 * @event flix:thumbs:up:add
 * @event flix:thumbs:up:remove
 * @event flix:thumbs:down:add
 * @event flix:thumbs:down:remove
 */
var FlixThumbs = function () {
  var FlixThumbs = {};

  /**
   * Thumbs up for the video
   * @param {number} vid 
   */
  FlixThumbs.up = function (vid) {
    var btnUp = document.querySelector('#thumbs-up');
    var btnDown = document.querySelector('#thumbs-down');
    if (btnUp.classList.contains('active')) {
      // remove like
      btnUp.classList.remove('active');
      document.dispatchEvent(new Event('flix:thumbs:up:remove'));
    } else {
      // add like
      btnUp.classList.add('active');
      btnDown.classList.remove('active');
      document.dispatchEvent(new Event('flix:thumbs:up:add'));
    }
    FlixUtils.request(Flix.urlLangPrefix + '/ajax/thumb-vote/' + vid + '?thumb=1', {
      method: 'POST'
    }).then(function (res) {
      return setNumbers(res);
    })["catch"](function (err) {
      return FlixStats.increment('thumbs_up_request_error');
    });
  };

  /**
   * Thumbs down for the video
   * @param {number} vid 
   */
  FlixThumbs.down = function (vid) {
    var btnUp = document.querySelector('#thumbs-up');
    var btnDown = document.querySelector('#thumbs-down');
    if (btnDown.classList.contains('active')) {
      // remove dislike
      btnDown.classList.remove('active');
      document.dispatchEvent(new Event('flix:thumbs:down:remove'));
    } else {
      // add dislike
      btnDown.classList.add('active');
      btnUp.classList.remove('active');
      document.dispatchEvent(new Event('flix:thumbs:down:add'));
    }
    FlixUtils.request(Flix.urlLangPrefix + '/ajax/thumb-vote/' + vid + '?thumb=-1', {
      method: 'POST'
    }).then(function (res) {
      return setNumbers(res);
    })["catch"](function (err) {
      return FlixStats.increment('thumbs_down_request_error');
    });
  };
  function setNumbers(response) {
    document.querySelector('#thumbs-up .thumb-count').innerHTML = response['up'];
    document.querySelector('#thumbs-down .thumb-count').innerHTML = response['down'];
  }
  ;
  return FlixThumbs;
}();